var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13617 0.636327C1.42907 0.343434 1.90394 0.343434 2.19683 0.636327L7.49984 5.93933L12.8028 0.636327C13.0957 0.343433 13.5706 0.343433 13.8635 0.636327C14.1564 0.92922 14.1564 1.40409 13.8635 1.69699L8.03017 7.53032C7.73727 7.82321 7.2624 7.82321 6.96951 7.53032L1.13617 1.69699C0.843281 1.40409 0.843281 0.929221 1.13617 0.636327Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.ea828d0f5320a4d0bbf71899f53064fb.svg";
export { ForwardRef as ReactComponent };